<template>
  <div class="container py-2">
    <div class="status-wrapper">

      <div class="status-header">
        <h3>Konfirmasi & Sanggahan</h3>
        <p class="instruction-text">Apakah Anda bermaksud untuk menyanggah pelanggaran yang tercantum pada detail
          sebelumnya?</p>
      </div>

      <div class="decision-container">
        <label class="decision-card" :class="{ active: inginSanggah === false }">
          <input type="radio" v-model="inginSanggah" :value="false" class="hidden-radio" />
          <div class="card-content">
            <i class="bi bi-check-circle-fill text-success icon-decision"></i>
            <div class="text-group">
              <span class="main-label">Konfirmasi Benar Melanggar</span>
              <span class="sub-label">Saya mengakui pelanggaran ini dan tidak melakukan sanggahan.</span>
            </div>
          </div>
        </label>

        <label class="decision-card" :class="{ active: inginSanggah === true }">
          <input type="radio" v-model="inginSanggah" :value="true" class="hidden-radio" />
          <div class="card-content">
            <i class="bi bi-exclamation-octagon-fill text-warning icon-decision"></i>
            <div class="text-group">
              <span class="main-label">Ajukan Sanggahan Pelanggaran</span>
              <span class="sub-label">Data tidak sesuai / kendaraan sudah terjual / nopol duplikat.</span>
            </div>
          </div>
        </label>
      </div>

      <div v-if="inginSanggah === true" class="table-responsive mt-4 fade-in">
        <table class="modern-table">
          <tbody>
            <tr class="section-row">
              <td colspan="2">Detail Formulir Sanggahan</td>
            </tr>

            <tr>
              <th>Tipe Sanggahan <span class="text-danger">*</span></th>
              <td>
                <div class="custom-select-wrapper">
                  <select v-model="idTipeSanggahan" class="modern-select" required>
                    <option :value="null" disabled selected>— Pilih Alasan Sanggahan —</option>
                    <option v-for="opt in confirmationOptions" :key="opt.id" :value="opt.id">
                      {{ opt.name }}
                    </option>
                  </select>
                  <span class="custom-select-arrow"></span>
                </div>
              </td>
            </tr>

            <tr>
              <th>Keterangan Sanggahan <span class="text-danger">*</span></th>
              <td>
                <div class="textarea-container">
                  <textarea v-model="alasan" rows="5" class="modern-textarea"
                    placeholder="Tuliskan kronologi sanggahan Anda secara terperinci di sini..." required></textarea>
                  <div class="textarea-footer">
                    <span class="word-counter">
                      {{ kataSanggahan }} kata
                    </span>
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <th>Dokumen Pendukung <span class="text-danger">*</span></th>
              <td>
                <div class="upload-container">
                  <label class="dropzone-area" :class="{ 'has-file': dokumenFile }">
                    <input type="file" ref="fileInput" @change="handleFileChange" accept=".png,.jpg,.jpeg,.pdf"
                      class="hidden-file-input" />
                    <div class="dropzone-content">
                      <i :class="dokumenFile ? 'bi bi-file-earmark-check-fill text-success' : 'bi bi-cloud-upload'"></i>
                      <div class="dropzone-text">
                        <p v-if="!dokumenFile" class="main-text">Klik atau seret file ke sini untuk mengunggah berkas
                        </p>
                        <p v-else class="file-name-text">{{ dokumenFile.name }}</p>
                        <p class="sub-text">Format yang didukung: JPG, PNG, atau PDF (Maksimal 5MB)</p>
                      </div>
                    </div>
                    <button v-if="dokumenFile" type="button" class="btn-remove-file" @click.prevent="removeFile">
                      <i class="bi bi-x-circle-fill"></i>
                    </button>
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="action-group" :class="{ 'mt-5': inginSanggah !== null }">
        <button type="button" class="btn-back" @click="$emit('prev')">
          <i class="bi bi-arrow-left"></i> Kembali
        </button>
        <button type="button" class="btn-next" @click="submitStep3">
          {{ inginSanggah === true ? 'Lanjut ke Konfirmasi Akhir' : 'Lanjut ke Konfirmasi Benar' }} <i
            class="bi bi-arrow-right"></i>
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  props: {
    noReferensi: String,
    noPolisi: String,
    pelanggaranData: Array,

    step3Data: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      inginSanggah: null,

      idTipeSanggahan: null,
      alasan: "",
      dokumenFile: null,

      confirmationOptions: [
        {
          id: 1,
          value: "duplikat_nopol",
          name: "Duplikat Nopol"
        },
        {
          id: 2,
          value: "kir_tidak_sesuai",
          name: "Data KIR tidak sesuai (Tanggal masa berlaku/KIR tidak sesuai)"
        },
        {
          id: 3,
          value: "kendaraan_terjual",
          name: "Kendaraan terjual"
        },
        {
          id: 4,
          value: "kendaraan_hilang",
          name: "Kendaraan hilang"
        },
        {
          id: 5,
          value: "DLL",
          name: "Dan Lain Lain"
        },
      ],
    };
  },

  computed: {
    kataSanggahan() {
      if (!this.alasan || !this.alasan.trim()) {
        return 0;
      }

      return this.alasan
        .trim()
        .split(/\s+/)
        .filter(word => word.length > 0)
        .length;
    }
  },

  mounted() {
    this.restoreState();
  },

  watch: {
    step3Data: {
      handler() {
        this.restoreState();
      },
      deep: true,
      immediate: true
    },

    inginSanggah: "saveState",
    idTipeSanggahan: "saveState",
    alasan: "saveState",
    dokumenFile: "saveState",
  },

  methods: {

    restoreState() {
      if (!this.step3Data) return;

      this.inginSanggah = this.step3Data.inginSanggah ?? null;
      this.idTipeSanggahan = this.step3Data.idTipeSanggahan ?? null;
      this.alasan = this.step3Data.alasan || "";
      this.dokumenFile = this.step3Data.dokumenFile || null;
    },

    saveState() {
      this.$emit("save-step3", {
        inginSanggah: this.inginSanggah,
        idTipeSanggahan: this.idTipeSanggahan,
        alasan: this.alasan,
        dokumenFile: this.dokumenFile,
      });
    },

    handleFileChange(event) {
      const file = event.target.files[0];

      if (!file) {
        return;
      }

      const allowedExtensions = ["png", "jpg", "jpeg", "pdf"];
      const fileName = file.name.toLowerCase();
      const fileExtension = fileName.split(".").pop();

      if (!allowedExtensions.includes(fileExtension)) {
        Swal.fire({
          title: "Format File Tidak Didukung!",
          text: "Silakan unggah file dengan format PNG, JPG, JPEG, atau PDF.",
          icon: "error",
          confirmButtonColor: "#2563eb",
        });

        this.removeFile();
        return;
      }
      
      if (file.size > 5 * 1024 * 1024) {
        Swal.fire({
          title: "File Terlalu Besar!",
          text: "Ukuran berkas dokumen pendukung maksimal adalah 5MB.",
          icon: "error",
          confirmButtonColor: "#2563eb",
        });

        this.removeFile();
        return;
      }
      this.dokumenFile = file;
    },


    removeFile() {

      this.dokumenFile = null;

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }

    },

    submitStep3() {
      if (this.inginSanggah === null) {
        Swal.fire({
          title: "Perhatian!",
          text: "Silakan pilih konfirmasi benar atau ajukan sanggahan terlebih dahulu.",
          icon: "warning",
          confirmButtonColor: "#2563eb"
        });
        return;
      }
      if (this.inginSanggah === true) {
        if (!this.idTipeSanggahan) {
          Swal.fire({
            title: "Perhatian!",
            text: "Silakan pilih tipe alasan sanggahan.",
            icon: "warning",
            confirmButtonColor: "#2563eb"
          });

          return;
        }
        if (!this.alasan || !this.alasan.trim()) {
          Swal.fire({
            title: "Perhatian!",
            text: "Silakan isi keterangan sanggahan.",
            icon: "warning",
            confirmButtonColor: "#2563eb"
          });

          return;
        }
        if (!this.dokumenFile) {

          Swal.fire({
            title: "Perhatian!",
            text: "Silakan unggah dokumen pendukung terlebih dahulu.",
            icon: "warning",
            confirmButtonColor: "#2563eb"
          });

          return;
        }
        const selectedOpt = this.confirmationOptions.find(
          item => item.id === this.idTipeSanggahan
        );

        this.saveState();
        this.$emit("next", {
          noReferensi: this.noReferensi,
          noPolisi: this.noPolisi,
          pelanggaranData: this.pelanggaranData,

          inginSanggah: this.inginSanggah,
          milik: 2,

          idTipeSanggahan: this.idTipeSanggahan,
          namaTipeSanggahan:
            selectedOpt ? selectedOpt.name : "",
          alasan: this.alasan,
          dokumenFile: this.dokumenFile,

          status: "SANGGAHAN",
          confirmation_type: 2
        });
        return;
      }

      this.saveState();
      this.$emit("next", {
        noReferensi: this.noReferensi,
        noPolisi: this.noPolisi,
        pelanggaranData: this.pelanggaranData,

        inginSanggah: this.inginSanggah,
        milik: 1,

        idTipeSanggahan: null,
        namaTipeSanggahan: "",
        alasan: "Menerima hasil konfirmasi pelanggaran.",
        dokumenFile: null,

        status: "KONFIRMASI_BENAR",
        confirmation_type: 1
      });
    }
  }
};
</script>

<style scoped>
.status-wrapper {
  background: #ffffff;
  padding: 35px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.04);
}

.status-header {
  margin-bottom: 25px;
}

.status-header h3 {
  font-size: 30px;
  font-weight: normal;
  color: #0f2f5f;
  margin-bottom: 12px;
}

.instruction-text {
  color: #2d3748;
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 0;
}

.decision-container {
  display: flex;
  gap: 20px;
  margin-bottom: 10px;
}

.decision-card {
  flex: 1;
  background: #f8fafc;
  border: 2px solid #cbd5e1;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.25s ease;
  user-select: none;
}

.decision-card:hover {
  border-color: #94a3b8;
  background: #f1f5f9;
}

.decision-card.active {
  border-color: #2563eb;
  background: #eff6ff;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.08);
}

.hidden-radio {
  display: none;
}

.card-content {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.icon-decision {
  font-size: 26px;
  margin-top: 2px;
}

.text-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.main-label {
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
}

.sub-label {
  font-size: 15px;
  color: #475569;
  line-height: 1.4;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.modern-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 12px;
}

.modern-table th {
  width: 260px;
  text-align: left;
  padding: 16px 20px;
  font-weight: normal;
  font-size: 18px;
  color: #1e293b;
  background: #f1f5fb;
  border-radius: 10px 0 0 10px;
  border-left: 1px solid #cbd5e1;
  border-top: 1px solid #cbd5e1;
  border-bottom: 1px solid #cbd5e1;
}

.modern-table td {
  padding: 16px 20px;
  background: #ffffff;
  border-radius: 0 10px 10px 0;
  font-size: 18px;
  color: #000000;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
  border-right: 1px solid #cbd5e1;
  border-top: 1px solid #cbd5e1;
  border-bottom: 1px solid #cbd5e1;
}

.section-row td {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  font-weight: normal;
  color: #0f2f5f;
  padding: 12px 0 4px 4px;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.custom-select-wrapper {
  position: relative;
  width: 100%;
}

.modern-select {
  width: 100%;
  padding: 14px 20px;
  font-size: 17px;
  color: #1e293b;
  background-color: #f8fafc;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  appearance: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modern-select:focus {
  outline: none;
  border-color: #2563eb;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.custom-select-arrow {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #64748b;
  pointer-events: none;
}

.textarea-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.modern-textarea {
  width: 100%;
  padding: 16px;
  font-size: 17px;
  color: #1e293b;
  background-color: #f8fafc;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  resize: vertical;
  transition: all 0.2s ease;
}

.modern-textarea:focus {
  outline: none;
  border-color: #2563eb;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.textarea-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-hint {
  font-size: 14px;
  color: #64748b;
}

.word-counter {
  font-size: 14px;
  font-weight: 500;
  color: #ef4444;
  background: #fef2f2;
  padding: 4px 10px;
  border-radius: 6px;
}

.word-counter.counter-success {
  color: #16a34a;
  background: #f0fdf4;
}

.dropzone-area {
  display: block;
  width: 100%;
  padding: 30px 20px;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
}

.dropzone-area:hover {
  border-color: #2563eb;
  background: #f1f5f9;
}

.dropzone-area.has-file {
  border-color: #16a34a;
  background: #f0fdf4;
}

.hidden-file-input {
  display: none;
}

.dropzone-content i {
  font-size: 36px;
  color: #64748b;
  display: inline-block;
  margin-bottom: 12px;
}

.dropzone-text .main-text {
  font-size: 16px;
  color: #334155;
  margin: 0 0 4px 0;
}

.dropzone-text .file-name-text {
  font-size: 16px;
  font-weight: 600;
  color: #16a34a;
  margin: 0 0 4px 0;
}

.dropzone-text .sub-text {
  font-size: 13px;
  color: #64748b;
  margin: 0;
}

.btn-remove-file {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  color: #ef4444;
  font-size: 20px;
  cursor: pointer;
}

.action-group {
  display: flex;
  justify-content: space-between;
  margin-top: 35px;
  gap: 20px;
}

.btn-back {
  background: #f1f5f9;
  color: #334155;
  border: 2px solid #cbd5e1;
  padding: 0 24px;
  height: 56px;
  border-radius: 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: 0.2s;
}

.btn-back:hover {
  background: #e2e8f0;
}

.btn-next {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  border: none;
  padding: 0 32px;
  height: 56px;
  border-radius: 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: 0.2s;
}

.btn-next:hover {
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);
}

.fade-in {
  animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .decision-container {
    flex-direction: column;
    gap: 12px;
  }

  .modern-table,
  .modern-table tbody,
  .modern-table tr,
  .modern-table th,
  .modern-table td {
    display: block;
    width: 100% !important;
  }

  .modern-table tr:not(.section-row) {
    margin-bottom: 12px;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    overflow: hidden;
  }

  .modern-table th {
    padding: 10px 14px;
    font-size: 15px;
    background: #f8fafc;
    border: none;
    border-bottom: 1px solid #e2e8f0;
  }

  .modern-table td {
    padding: 12px 14px;
    font-size: 17px;
    border: none;
  }

  .action-group {
    flex-direction: column-reverse;
    gap: 12px;
  }

  .btn-back,
  .btn-next {
    width: 100%;
    height: 58px;
  }
}
</style>